import { environment } from "@environments/environment";
import { configuration } from "properties/config";

export const APP_ROUTES = {
  LOGIN: "/login",
  SIGNUP: "/signup",
  RESET_PASSWORD: "/resetpassword",
  PROXY: environment.gigyaProxyUrl,
  CALLBACK: environment.gigyaCallbackUrl,
};

export const SESSION_CONSTANTS = {
  ACCESS_TOKEN: "access_token",
  ACCESS_TOKEN_CAMEL: "accessToken",
  TOKEN: "token",
  AUTH_TOKEN: "authToken",
  JWT: "jwt",
  CSRF_TOKEN: "_csrf_token",
  PROFILE: "user_profile",
  USER_REGION: "user_region",
  IS_LOGGED_IN: "is_logged_in",
  IS_AUTHORIZED: "is_authorized",
  CUSTOMER_DETAILS: "customer_details",
  SELECTED_INJECTORS: "selected_injectors",
  USER_DETAILS: "user_details",
  USER_INJECTOR_DATA_ACCESS: "user_injector_data_access",
  EXPIRES_IN: "expires_in",
  DECODED_TOKEN_DATA: "decoded_token_data",
  CHECK_INTERVAL_IN_SECONDS: 60,
  SESSION_RENEW_SECONDS: 900,
  SHOW_TIMER_AT: 15,
  IS_TERMS_AND_CONDITIONS_ACCEPTED: "isTermsAndConditionsAccepted",
  DEFAULT_ASSIGNED_REGION: "default_assigned_region",
  USER_ENTITLEMENT_SOFTWARE_PACKAGE: "user_entitlement_software_package",
  USER_MANDATORY_SOFTWARE_PACKAGE: "user_mandatory_software_package",
  SOFTWARE_PACKAGE_CACHE_TIME: "software_package_cache_time",
  TOKEN_COOKIE_NAMES: [
    "access_token",
    "accessToken",
    "token",
    "authToken",
    "jwt",
  ],
  USER_PROFILE_LOWER_DATA: "USER_PROFILE_LOWER_DATA",
  X_REGION: "x-region",
  AUDIT_LOG_REGION: "audit_log_region", // Audit log selected region
  CUSTOMER_ONBOARDING_REGION: "customer-onboarding-region",
  ANALYTICS_REGION: "analytics_region", // Analytics selected region
};

/**
 * HTTP Interceptor Configuration
 * Define which endpoints should be excluded from automatic credential injection
 * and how region-based routing should be handled
 */
export const HTTP_INTERCEPTOR_CONFIG = {
  CREDENTIALS_EXCLUDED_ENDPOINTS: [
    configuration.authUrls.login,
    configuration.authUrls.resetPassword,
    configuration.authUrls.signUp,
  ],
  X_REGION_HEADER_ADDITION: [
    configuration.partialUrls.userManagement.getUsers,
    configuration.partialUrls.userManagement.userDetailsFromToken,
    "search/user-management", // Direct path to handle URL prefixes
  ],
  AUDIT_LOG_REGION_HEADER_ADDITION: [
    "event-logs-frontend", // Audit logs endpoints
     "event-logs/filters",
     "event-logs",
  ],
  CUSTOMER_ONBOARDING_REGION_HEADER_ADDITION: [
    "customer-onboarding",
    "search/customer-onboarding",
    "injectors",
    "search/injectors",
  ],
  ANALYTICS_REGION_HEADER_ADDITION: [
    "analytics",
    "software-analytics",
    "user-analytics",
    "customer-analytics",
    "injector-data-analytics",
  ],
  URL_REGION_MODIFICATION: [
    "user-management",
    "customer-onboarding",
    "injectors",
    "reference",
    "auth",
    "event-logs-frontend",
    "event-logs/filters",
    "event-logs",
    "analytics",
    "software-analytics",
    "user-analytics",
    "customer-analytics",
    "injector-data-analytics",
    "global-search",
  ],
  URL_REGION_MODIFICATION_EXCLUDED: [
    configuration.partialUrls.userManagement.userDetailsFromToken, // "/user-management/me"
    // "user-management/accept-terms-and-condition", // Accept terms and condition endpoint
    // Add more endpoints here that should use X-Region header instead of URL modification
  ],
};
